import { ComponentProps, JSXElementConstructor } from 'react';
import { registerModals } from '@bonanza-social/navigation';
import { RegistrationLimitsModalScreen } from '@bonanza-social/registration';

import ChangePasswordModal from './ChangePasswordModal';
import AuthNavigator from '../navigators/AuthNavigator/AuthNavigator';

const modals = {
  Auth: AuthNavigator,
  ChangePassword: ChangePasswordModal,
  RegistrationLimitsModal: RegistrationLimitsModalScreen,
};

registerModals('auth', modals);

declare global {
  interface RegisteredModals {
    auth: {
      [K in keyof typeof modals]: JSXElementConstructor<
        ComponentProps<(typeof modals)[K]>
      >;
    };
  }
}
